/* Pradawne Dary: drobne zachowania motywu. Bez zależności, ładowane z defer. */

/* Kafelki innych wersji: najechanie podgląda nazwę, opuszczenie przywraca aktualną. */
document.addEventListener('pointerover', (event) => {
  const item = event.target.closest('[data-ab-siblings] .ab-siblings__item');
  if (!item) return;
  const label = item.closest('.ab-siblings')?.querySelector('[data-ab-siblings-label]');
  if (label) label.textContent = item.dataset.label;
});

document.addEventListener('pointerout', (event) => {
  const list = event.target.closest('[data-ab-siblings]');
  if (!list || list.contains(event.relatedTarget)) return;
  const label = list.closest('.ab-siblings')?.querySelector('[data-ab-siblings-label]');
  if (label) label.textContent = label.dataset.default;
});

/* „Realizuj zakup” w koszyku: kółko jak przy „Dodaj do koszyka”, dopóki kasa się nie otworzy. */
document.addEventListener('click', (event) => {
  const button = event.target.closest('#CartDrawer-Checkout, #checkout');
  if (!button || button.disabled || button.classList.contains('loading')) return;
  button.classList.add('loading');
  button.setAttribute('aria-busy', 'true');
  button.querySelector('.loading__spinner')?.classList.remove('hidden');
});

/* Powrót przyciskiem „wstecz” z kasy pokazuje stronę z pamięci, więc zdejmujemy kółko. */
window.addEventListener('pageshow', () => {
  document.querySelectorAll('#CartDrawer-Checkout.loading, #checkout.loading').forEach((button) => {
    button.classList.remove('loading');
    button.removeAttribute('aria-busy');
    button.querySelector('.loading__spinner')?.classList.add('hidden');
  });
});

/* Przyklejony pasek zakupu. Widoczny cały czas, na telefonie i na komputerze (właściciel 03.11). */
if (!customElements.get('ab-sticky-atc')) {
  customElements.define(
    'ab-sticky-atc',
    class AbStickyAtc extends HTMLElement {
      connectedCallback() {
        if (this.closest('quick-add-modal')) return;

        this.form = document.getElementById(this.dataset.formId);
        this.submit = this.form?.querySelector('[type="submit"]');
        if (!this.submit) return;

        this.button = this.querySelector('[data-ab-add]');
        this.label = this.querySelector('[data-ab-label]');
        this.priceEl = this.querySelector('[data-ab-price]');

        this.button.addEventListener('click', () => {
          if (this.submit.disabled || this.loading) return;
          this.setLoading(true);
          /* Zabezpieczenie: gdyby formularz nie wystartował, przycisk wraca po 8 s. */
          clearTimeout(this.loadingTimer);
          this.loadingTimer = setTimeout(() => this.setLoading(false), 8000);
          this.submit.click();
        });

        /* Klik w pasek (poza przyciskiem) przewija do wyboru zestawu, a gdy go nie ma, do przycisku. */
        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-ab-add]')) return;
          const target = this.form.closest('product-info')?.querySelector('.ab-zs') || this.submit;
          const top = target.getBoundingClientRect().top + window.scrollY - 90;
          window.scrollTo({ top, behavior: 'smooth' });
        });

        /* Pasek widać cały czas (także gdy główny przycisk jest na ekranie). */
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.offscreen = true;
        this.observer = new IntersectionObserver(([entry]) => {
          this.offscreen = !entry.isIntersecting;
          this.toggle(true);
        });
        this.mobile.addEventListener('change', () => this.toggle(true));
        this.observer.observe(this.submit);

        /* Wariant, dostępność i cena zmieniają się po stronie Dawn. Tylko je kopiujemy. */
        this.sync = this.sync.bind(this);
        this.mutations = new MutationObserver(this.sync);
        this.watch();
        this.sync();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.mutations?.disconnect();
      }

      watch() {
        this.mutations.disconnect();
        const info = this.submit.closest('product-info') || document;
        const price = document.getElementById(this.dataset.priceId);
        this.mutations.observe(this.submit, { attributes: true, childList: true, subtree: true, characterData: true });
        if (price) this.mutations.observe(price, { childList: true, subtree: true, characterData: true });
        this.info = info;
      }

      sync() {
        const fresh = this.form?.querySelector('[type="submit"]');
        if (fresh && fresh !== this.submit) {
          this.submit = fresh;
          this.observer.disconnect();
          this.observer.observe(this.submit);
          this.watch();
        }

        /* Główny przycisk w trakcie dodawania ma klasę loading; pasek pokazuje wtedy to samo kółko. */
        const busy = this.submit.classList.contains('loading');
        if (busy) {
          this.setLoading(true);
        } else if (this.loading && this.submit.getAttribute('aria-disabled') !== 'true') {
          this.setLoading(false);
        }
        this.button.disabled = this.submit.disabled || (this.submit.getAttribute('aria-disabled') === 'true' && !this.loading);
        const text = this.submit.querySelector('span')?.textContent.trim();
        if (text) this.label.textContent = text;

        const price = document.getElementById(this.dataset.priceId);
        if (price && this.priceEl) {
          const onSale = price.querySelector('.price--on-sale');
          const current = onSale
            ? price.querySelector('.price__sale .price-item--last')
            : price.querySelector('.price__regular .price-item--regular');
          const value = current?.textContent.trim();
          if (value) this.priceEl.textContent = value;
        }
      }

      setLoading(on) {
        if (on === this.loading) return;
        this.loading = on;
        this.button.classList.toggle('loading', on);
        this.button.setAttribute('aria-busy', String(on));
        this.button.querySelector('.loading__spinner')?.classList.toggle('hidden', !on);
        if (!on) clearTimeout(this.loadingTimer);
      }

      toggle(show) {
        if (show === this.visible) return;
        this.visible = show;
        this.classList.toggle('is-visible', show);
        this.toggleAttribute('inert', !show);
        this.setAttribute('aria-hidden', String(!show));
        document.body.classList.toggle('ab-has-sticky-atc', show);
      }
    }
  );
}

/* Rząd produktów: przewijanie strzałkami, stan strzałek zależy od pozycji. */
if (!customElements.get('ab-product-row')) {
  customElements.define(
    'ab-product-row',
    class AbProductRow extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ab-row__track');
        const root = this.closest('.ab-row');
        this.prev = root?.querySelector('[data-ab-row-prev]');
        this.next = root?.querySelector('[data-ab-row-next]');
        if (!this.track) return;
        this.update = this.update.bind(this);
        this.prev?.addEventListener('click', () => this.go(-1));
        this.next?.addEventListener('click', () => this.go(1));
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        this.update();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.update);
        window.removeEventListener('resize', this.update);
      }

      go(dir) {
        const item = this.track.querySelector('.ab-row__item');
        const step = item ? item.getBoundingClientRect().width : this.track.clientWidth / 4;
        const per = Math.max(1, Math.floor(this.track.clientWidth / step));
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: dir * step * per, behavior: reduce ? 'auto' : 'smooth' });
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max;
      }
    }
  );
}

/* Founder video card under the buy button (snippets/ab-founder-video.liquid).
   Dawn re-renders the buy buttons with innerHTML, so cards are picked up here, also after re-renders. */
(function () {
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target.querySelector('video');
      if (e.isIntersecting) { load(v); } else if (v.getAttribute('src')) { v.pause(); }
    });
  }, { rootMargin: '200px' }) : null;
  function load(v) { if (!v.getAttribute('src')) { v.src = v.dataset.src; } v.play().catch(function () {}); }
  function init(box) {
    if (box.dataset.abFvidOn) return;
    box.dataset.abFvidOn = '1';
    var v = box.querySelector('video');
    if (io) { io.observe(box); } else { load(v); }
    box.querySelector('.ab-fvid__media').addEventListener('click', function () { open(v); });
  }
  function open(thumb) {
    thumb.pause();
    var m = document.createElement('div');
    m.className = 'ab-fvid-modal';
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.setAttribute('aria-label', thumb.dataset.label || 'Film: Łukasz z Pradawnych Darów');
    m.innerHTML = '<div class="ab-fvid-modal__box"><video playsinline muted autoplay></video>' +
      '<button type="button" class="ab-fvid-modal__sound" aria-pressed="false" aria-label="Włącz dźwięk">' +
      '<svg class="ab-fvid-i-off" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5L6 9H3v6h3l5 4z" fill="currentColor"/><path d="M22 9l-6 6M16 9l6 6"/></svg>' +
      '<svg class="ab-fvid-i-on" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5L6 9H3v6h3l5 4z" fill="currentColor"/><path d="M15.5 8.5a5 5 0 010 7M18.5 5.5a9 9 0 010 13"/></svg></button>' +
      '<button type="button" class="ab-fvid-modal__close" aria-label="Zamknij film"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<div class="ab-fvid-modal__bar"><input class="ab-fvid-modal__seek" type="range" min="0" max="1000" step="1" value="0" aria-label="Przewiń film"><span class="ab-fvid-modal__ticks" aria-hidden="true"></span></div></div>';
    var mv = m.querySelector('video');
    mv.muted = true;
    mv.src = thumb.dataset.src;
    var seek = m.querySelector('.ab-fvid-modal__seek');
    var ticks = m.querySelector('.ab-fvid-modal__ticks');
    var dragging = false;
    function paint() { seek.style.setProperty('--p', (seek.value / 10) + '%'); }
    mv.addEventListener('timeupdate', function () {
      if (dragging || !mv.duration) return;
      seek.value = Math.round(mv.currentTime / mv.duration * 1000);
      paint();
    });
    seek.addEventListener('input', function () {
      dragging = true;
      if (mv.duration) mv.currentTime = seek.value / 1000 * mv.duration;
      paint();
    });
    ['change', 'pointerup', 'touchend', 'keyup'].forEach(function (ev) { seek.addEventListener(ev, function () { dragging = false; }); });
    /* Rozdziały: znaczniki na pasku (data-chapters="16,26,33" w sekundach). Dotknięcie paska przewija w to miejsce. */
    function drawTicks() {
      if (!thumb.dataset.chapters || !mv.duration) return;
      ticks.innerHTML = thumb.dataset.chapters.split(',').map(function (t) {
        return '<i style="left:' + (parseFloat(t) / mv.duration * 100) + '%"></i>';
      }).join('');
    }
    mv.addEventListener('loadedmetadata', drawTicks);
    paint();
    var sound = m.querySelector('.ab-fvid-modal__sound');
    sound.addEventListener('click', function () {
      mv.muted = !mv.muted;
      sound.setAttribute('aria-pressed', String(!mv.muted));
      sound.setAttribute('aria-label', mv.muted ? 'Włącz dźwięk' : 'Wycisz');
      if (mv.paused) mv.play().catch(function () {});
    });
    mv.addEventListener('click', function () { if (mv.paused) { mv.play().catch(function () {}); } else { mv.pause(); } });
    var closeBtn = m.querySelector('.ab-fvid-modal__close');
    function close() {
      mv.pause(); m.remove(); document.documentElement.classList.remove('ab-fvid-lock');
      document.removeEventListener('keydown', onKey);
      thumb.play().catch(function () {});
      var b = box(thumb); if (b) b.focus();
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    m.addEventListener('click', function (e) { if (e.target === m) close(); });
    closeBtn.addEventListener('click', close);
    mv.addEventListener('ended', close);
    document.addEventListener('keydown', onKey);
    document.documentElement.classList.add('ab-fvid-lock');
    document.body.appendChild(m);
    mv.play().catch(function () {});
    closeBtn.focus();
  }
  function box(v) { return v.closest('.ab-fvid__media'); }
  function scan() { document.querySelectorAll('[data-ab-fvid]').forEach(init); }
  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  // Link z e-maila po zakupie: ?film=1 otwiera ten sam odtwarzacz (krzyżyk zamyka go i zostawia klienta w sklepie).
  if (/[?&]film=1\b/.test(location.search)) {
    var t = document.createElement('video');
    t.dataset.src = 'https://cdn.shopify.com/videos/c/o/v/8ac0aa333cbd47c1aacc68baa4d53500.mp4';
    open(t);
  }
})();
